


















































































































import Component, {mixins} from "vue-class-component";
import {Prop} from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import {MyOptions} from "@/charts/graphData";
import MobileMixin from "@/mixins/mobileMixin";
import CaGraph from "@/homeGraph/CaGraph.vue";
import CaDataPresta from "@/homeGraph/CaDataPresta.vue";
import EquipementsPrestaGraph from "@/homeGraph/EquipementsPrestaGraph.vue";
import TicketMoyen from "@/homeGraph/TicketMoyen.vue";
import CaTotalGraph from "@/homeGraph/CaTotalGraph.vue";
import TotalBarGraph from "@/homeGraph/totalBarGraph.vue";
import moment from "moment/moment";
import axios from "@/plugins/axios";

@Component({
  components: {
    CaGraph,
    CaDataPresta,
    EquipementsPrestaGraph,
    TicketMoyen,
    CaTotalGraph,
    TotalBarGraph,
  },
})
export default class TotalHome extends mixins(MyMixin, MobileMixin) {
  @Prop() public myOptions!: MyOptions;

  /**
   * à supprimer
   */
  public generateBBL() {
    const date = moment(this.myOptions.date).format("YYYY-MM-DD");
    const URL =
        axios.defaults.baseURL + "bo/bbl/exportdate?datefiscale=" + date;
    // console.log(URL);
    window.open(URL);
  }
}
